import { useState } from "react";
import "./DonePayment.scss";

export default function DonePayment({
  setProgress,
  progress,
  setIsCancelled,
  selectedOrders,
  onClose,
}) {
  return (
    <>
      <div className="done-modal-container">
        <h2>DONE</h2>
        <span className="subject">Thank you for choosing us!!</span>
        <div className="action-button">
          <button className="proceed" onClick={onClose}>
            DONE
          </button>
        </div>
      </div>
    </>
  );
}
